import type { SEOPageType } from '@iheartjane/data-access';

export const SEO_VARIABLES: Record<SEOPageType, string[]> = {
  category: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'category',
  ],
  customRow: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'rowName',
  ],
  deal: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'specialName',
    'rowName',
  ],
  featured: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
  ],
  pdp: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'productName',
    'productLineage',
    'productCategory',
    'productSubCategory',
    'productBrand',
  ],
  shopAll: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'category',
  ],
};

export const SEO_URLS: Record<SEOPageType, string> = {
  category: '/shop/category',
  customRow: '/shop/customRow/<id>/<rowName>',
  deal: '/shop/deals/<id>/<slug>',
  featured: '/shop',
  pdp: '/shop/products/<id>/<slug>',
  shopAll: '/shop/shop-all',
};

interface NavLink {
  label: string;
  value: SEOPageType;
}

export const NAV_LINKS: NavLink[] = [
  { label: 'Featured', value: 'featured' },
  { label: 'Category', value: 'category' },
  { label: 'Deal', value: 'deal' },
  { label: 'Shop All', value: 'shopAll' },
  { label: 'Custom Row', value: 'customRow' },
  { label: 'PDP', value: 'pdp' },
];
